import { useState } from "react";

interface PropertyGroupProps {
  title: string;
  /** If true, section starts open. Otherwise auto-opens only if hasValues is true. */
  defaultOpen?: boolean;
  /** Set to true when any property in this group has a non-default value. */
  hasValues?: boolean;
  children: React.ReactNode;
}

/**
 * Collapsible property group. Auto-opens when non-default values are present.
 */
export function PropertyGroup({
  title,
  defaultOpen,
  hasValues,
  children,
}: PropertyGroupProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen ?? hasValues ?? false);

  return (
    <div className="mb-1">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex w-full items-center gap-1.5 rounded-radius-sm px-2 py-1.5 text-left transition-colors hover:bg-surface-sunken"
      >
        <span className={`text-[10px] text-text-muted transition-transform ${isOpen ? "rotate-90" : ""}`}>
          ▶
        </span>
        <span className="text-[11px] font-medium text-text-secondary">{title}</span>
        {hasValues && (
          <span className="ml-auto h-1.5 w-1.5 rounded-full bg-accent" title="Has custom values" />
        )}
      </button>
      {isOpen && (
        <div className="border-l-2 border-border-subtle ml-3 pl-3 pb-2 pt-1">
          {children}
        </div>
      )}
    </div>
  );
}
